var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('button',{staticClass:"cookie_button",on:{"click":function($event){$event.preventDefault();return _vm.oneTrustModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Cookie button')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }